/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotActivityCountBase {
    getFixupPrototypeFunction() { return CopilotActivityCountBase.fixupPrototype; }

    static newInstance(model: Partial<CopilotActivityCountBase>): CopilotActivityCountBase {
        let obj = Object.assign(new CopilotActivityCountBase(), model);
        CopilotActivityCountBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotActivityCountBase>): CopilotActivityCountBase {
        if (!model) return null;
        return CopilotActivityCountBase.newInstance(<CopilotActivityCountBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotActivityCountBase) {
        if (!obj) return;

        models.CopilotActivityCountBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotActivityCountBase): boolean {
        Object.setPrototypeOf(obj, CopilotActivityCountBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.code_acceptance_activity_count === undefined) {
            this.code_acceptance_activity_count = 0;
        }
        if (this.code_generation_activity_count === undefined) {
            this.code_generation_activity_count = 0;
        }
    }

    /**
     * Number of code acceptance activities
     */
    code_acceptance_activity_count: number;

    /**
     * Number of code generation activities
     */
    code_generation_activity_count: number;

}
